import { render } from "./competition_user_completed.vue?vue&type=template&id=3d79ee56&scoped=true"
import script from "./competition_user_completed.vue?vue&type=script&lang=js"
export * from "./competition_user_completed.vue?vue&type=script&lang=js"

import "./competition_user_completed.vue?vue&type=style&index=0&id=3d79ee56&scoped=true&lang=css"

import exportComponent from "/home/stagging/consillium/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d79ee56"]])

export default __exports__